import { render, staticRenderFns } from "./EditCourseType.vue?vue&type=template&id=935f708e&scoped=true"
import script from "./EditCourseType.vue?vue&type=script&lang=js"
export * from "./EditCourseType.vue?vue&type=script&lang=js"
import style0 from "./EditCourseType.vue?vue&type=style&index=0&id=935f708e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935f708e",
  null
  
)

export default component.exports